import { createContext, useContext } from 'react';

type NethoneContext = {
  attemptReference: Promise<string | null>;
};

export const NethoneContext = createContext<NethoneContext | null>(null);

export const useNethoneContext = () => useContext(NethoneContext)!;
